//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { Edit } from '@mui/icons-material';
import { Button, Modal as ModalSection, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
//  -- Components ---------------------
import { Card, Col, Dropdown, Input, Menu, Row, Tabs, Button as ButtonDropdown, message } from 'antd';
import Loading from 'components/Loading';

//  -- Constants ----------------------
import { get, isEmpty } from 'lodash';
import COLOR from "utils/constants/color";
//  -- Thunks -------------------------
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAllBook } from 'store/books/selectors';
import { handleActiveInActiveBook, hanldeCloneBooks, handleUpdateBookGrade, handleActivityGradeConfig, handleCheckActivityCount, handleGetBookByChapter } from 'store/books/thunks';
import { useBookUnits } from 'store/booksUnits/selectors';
import SettingsIcon from '@mui/icons-material/Settings';
import CloneBookImage from 'components/AdminBooks/PageToolbarModals/CloneBookImage';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { useHasPermission } from 'utils/permissions';
import { STANDARD_GRADE_LEVEL } from 'utils/config/reference';
import { normalizeGradeLevel, isIllinoisOrCommonCoreState, getStateNameFromCode, getStateCodeFromName, statesMatch, getStateNameDisplayForCode } from 'utils/lib/standardHelper';
//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------

const StableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;
const ModalContent = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    border-radius: 3px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    max-width: 320px;
    padding: 16px;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
`;

const ModalRow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 16px;
    width: 100%;
`;
const FilterContainer = styled.span`
    font-size:17px;
    font-weight:500;
    cursor:pointer;
`;
const { TabPane } = Tabs;

const sortBookById = (books) => {
    if (Array.isArray(books)) {
        return [...books].sort((a, b) => parseInt(a.id, 10) - parseInt(b.id, 10));
    }
    return books;
};

const getGradeLevelsForState = (state) => {
    if (isIllinoisOrCommonCoreState(state)) {
        return ['6', '7', '8', '9-10', '11-12'];
    }
    return ['6', '7', '8', '9', '10', '11', '12'];
};

const normalizeGradeForDropdown = (gradeLevel, state) => {
    if (!gradeLevel) return gradeLevel;
    const normalized = normalizeGradeLevel(gradeLevel);
    if (isIllinoisOrCommonCoreState(state)) {
        if (normalized === '9' || normalized === '10') {
            return '9-10';
        }
        if (normalized === '11' || normalized === '12') {
            return '11-12';
        }
    }
    return normalized;
};

const getScrollOverflowAncestors = (node) => {
    const list = [];
    let cur = node && node.parentElement;
    while (cur) {
        const st = window.getComputedStyle(cur);
        if (/(auto|scroll|overlay)/.test(st.overflowY) || /(auto|scroll|overlay)/.test(st.overflowX)) {
            list.push(cur);
        }
        cur = cur.parentElement;
    }
    return list;
};
const BooksTable = ({ }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const bookUnits = useBookUnits();
    const booksAllList = useAllBook();
    const showAlert = useAlert();
    
    const hasViewBooks = useHasPermission('edit_books.view');
    const hasAddBooks = useHasPermission('edit_books.add');
    const hasEditBooks = useHasPermission('edit_books.edit');
    const hasActivateBooks = useHasPermission('edit_books.activate');
    
    const canEdit = hasEditBooks;
    const canAdd = hasAddBooks;
    const canActivate = hasActivateBooks;
    
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [ActiveLoader, setActiveLoader] = useState(-1);
    const [inActivepage, setInActivePage] = useState(0);
    const [alertForStatus, setAlertForStatus] = useState(false);
    const [bookToActive, setBookToActive] = useState({});
    const [bookStatus, setBookStatus] = useState('');
    const [cloneModal, setCloneModal] = useState(false);
    const [bookTitle, setBookTitle] = useState('');
    const [bookImage, setBookImage] = useState('');
    const [gradeModal, setGradeModal] = useState(false);
    const [bookToEditGrade, setBookToEditGrade] = useState(null);
    const [selectedGrade, setSelectedGrade] = useState('');
    const [selectedStates, setSelectedStates] = useState('Common Core');
    const [gradeLoader, setGradeLoader] = useState(false);
    const [rowsPerPageInActive, setRowsPerPageInActive] = useState(50);
    const [search, setSearch] = useState('');
    const [activityCount, setActivityCount] = useState(null);
    const [activityCountLoader, setActivityCountLoader] = useState(false);
    const [replaceGradeModal, setReplaceGradeModal] = useState(false);
    const [pendingGradeUpdate, setPendingGradeUpdate] = useState(null);
    const [activeTab, setActiveTab] = useState('1');
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [openBookActionsMenuId, setOpenBookActionsMenuId] = useState(null);
    const stableWrapperRef = useRef(null);
    const bookActionsMenuTriggerRef = useRef(null);

    const { filteredBooks, filteredBooksDeActive } = useMemo(() => {
        try {
            const list = Array.isArray(booksAllList) ? booksAllList : [];
            const needle = search && search.length > 1 ? search.toLowerCase() : '';
            if (needle) {
                const match = (x) =>
                    `${x.description}`.toLowerCase().includes(needle) ||
                    `${x.id}`.toLowerCase().includes(needle);
                return {
                    filteredBooks: sortBookById(list.filter((x) => x.active && match(x))),
                    filteredBooksDeActive: sortBookById(list.filter((x) => !x.active && match(x))),
                };
            }
            return {
                filteredBooks: sortBookById(list.filter((book) => book?.active)),
                filteredBooksDeActive: sortBookById(list.filter((book) => !book?.active)),
            };
        } catch {
            return { filteredBooks: null, filteredBooksDeActive: null };
        }
    }, [booksAllList, search, refreshTrigger]);

    const bookUnitIds = useMemo(() => {
        if (!Array.isArray(bookUnits)) {
            return new Set();
        }
        return new Set(bookUnits.map((u) => u.id));
    }, [bookUnits]);

    useEffect(() => {
        setPage(0);
    }, [booksAllList, search, refreshTrigger]);

    const handleSearch = useCallback((event) => {
        setSearch(event.target.value);
    }, []);

    const handleEditBook = useCallback(
        (bookId) => {
            navigate(`/add-book?bookId=${bookId}`);
        },
        [navigate]
    );

    const handleChangeRowsPerPage = useCallback((event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setOpenBookActionsMenuId(null);
    }, []);

    const handleChangePage = useCallback((event, newPage) => {
        setPage(newPage);
        setOpenBookActionsMenuId(null);
    }, []);

    const hasBookUnits = useCallback((id) => bookUnitIds.has(id), [bookUnitIds]);

    const handleTabChange = useCallback((key) => {
        setActiveTab(key);
        setOpenBookActionsMenuId(null);
    }, []);

    const handleActiveBook = async (bookId) => {
        setActiveLoader(bookId);
        await dispatch(handleActiveInActiveBook(bookId, false));
        setActiveLoader(-1);
        setAlertForStatus(false);
        setBookStatus('');
        setRefreshTrigger((prev) => prev + 1);
    };

    const handleDeActiveBook = async (bookId) => {
        setActiveLoader(bookId);
        await dispatch(handleActiveInActiveBook(bookId, true));
        setActiveLoader(-1);
        setAlertForStatus(false);
        setBookStatus('');
        setRefreshTrigger((prev) => prev + 1);
    };

    const handleClone = async () => {
        if (!bookTitle || !bookImage) {
            showAlert('Please fill in both Book Title and Book Image', 'warning');
            return;
        }
        setActiveLoader(2)
        const new_book = await dispatch(hanldeCloneBooks(bookToActive.id, bookTitle, bookImage))
        setActiveLoader(-1)
        setCloneModal(false)
        if (new_book && new_book.id) {
            showAlert('Book cloned successfully', 'success');
            handleEditBook(new_book.id)
        } else {
            showAlert('Something went wrong', 'error');
        }
    };

    const handleChangePageInActive = useCallback((event, newPage) => {
        setInActivePage(newPage);
        setOpenBookActionsMenuId(null);
    }, []);

    const handleChangeRowsPerPageinActive = useCallback((event) => {
        setRowsPerPageInActive(parseInt(event.target.value, 10));
        setInActivePage(0);
        setOpenBookActionsMenuId(null);
    }, []);

    const checkActivityCount = useCallback(async () => {
        if (!bookToEditGrade || !selectedGrade || !selectedStates) {
            return;
        }
        setActivityCountLoader(true);
        try {
            let stateForAPI =
                selectedStates && selectedStates.toUpperCase().trim() === 'COMMON CORE'
                    ? 'COMMONCORE'
                    : getStateNameFromCode(selectedStates) || selectedStates;
            if (stateForAPI !== 'COMMONCORE') {
                stateForAPI = stateForAPI.toUpperCase().trim();
            }
            const countResult = await dispatch(
                handleCheckActivityCount({
                    bookId: bookToEditGrade.id,
                    grade_level: selectedGrade,
                    state: stateForAPI,
                })
            );
            if (countResult && countResult?.success && countResult?.status_code === 200) {
                setActivityCount(countResult?.data || null);
            } else {
                setActivityCount(null);
            }
        } catch {
            setActivityCount(null);
        } finally {
            setActivityCountLoader(false);
        }
    }, [bookToEditGrade, dispatch, selectedGrade, selectedStates]);

    const gradeDropdownLevels = useMemo(
        () => getGradeLevelsForState(selectedStates),
        [selectedStates]
    );

    const paginatedActiveBooks = useMemo(() => {
        if (!Array.isArray(filteredBooks) || filteredBooks.length === 0) {
            return [];
        }
        return filteredBooks.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    }, [filteredBooks, page, rowsPerPage]);

    const paginatedInactiveBooks = useMemo(() => {
        if (!Array.isArray(filteredBooksDeActive) || filteredBooksDeActive.length === 0) {
            return [];
        }
        return filteredBooksDeActive.slice(
            inActivepage * rowsPerPageInActive,
            inActivepage * rowsPerPageInActive + rowsPerPageInActive
        );
    }, [filteredBooksDeActive, inActivepage, rowsPerPageInActive]);

    useEffect(() => {
        if (openBookActionsMenuId == null) {
            return undefined;
        }
        const close = () => setOpenBookActionsMenuId(null);
        const opts = { passive: true };
        const trigger = bookActionsMenuTriggerRef.current;
        const scrollAncestors = getScrollOverflowAncestors(trigger);
        window.addEventListener('scroll', close, opts);
        window.addEventListener('resize', close, opts);
        scrollAncestors.forEach((el) => el.addEventListener('scroll', close, opts));
        let io;
        if (trigger && typeof IntersectionObserver !== 'undefined') {
            const root = scrollAncestors[0] ?? null;
            io = new IntersectionObserver((entries) => {
                const [e] = entries;
                if (!e.isIntersecting) {
                    close();
                }
            }, { root, threshold: 0 });
            io.observe(trigger);
        }
        return () => {
            window.removeEventListener('scroll', close, opts);
            window.removeEventListener('resize', close, opts);
            scrollAncestors.forEach((el) => el.removeEventListener('scroll', close, opts));
            if (io) {
                io.disconnect();
            }
        };
    }, [openBookActionsMenuId]);

    useEffect(() => {
        if(gradeModal === true && bookToEditGrade?.id) {
            const bookId = bookToEditGrade.id;
            const fetchBookDetails = async () => {
                try {
                    const bookResponse = await dispatch(handleGetBookByChapter(bookId));
                    if (bookResponse && bookResponse[0]) {
                        const updatedBook = bookResponse[0];
                        setBookToEditGrade(updatedBook);
                    }
                } catch (error) {
                }
            };
            fetchBookDetails();
        }
    },[gradeModal, bookToEditGrade?.id])

    useEffect(() => {
        if(gradeModal === true && bookToEditGrade) {
            setSelectedStates('Common Core');
            const gradeLevels = getGradeLevelsForState('Common Core');
            if (bookToEditGrade?.grade_level) {
                const normalizedGrade = normalizeGradeForDropdown(bookToEditGrade.grade_level, 'Common Core');
                if (gradeLevels.includes(normalizedGrade)) {
                    setSelectedGrade(normalizedGrade);
                } else {
                    setSelectedGrade(gradeLevels[0] || '');
                }
            } else {
                setSelectedGrade(gradeLevels[0] || '');
            }
        }
    },[gradeModal, bookToEditGrade])

    useEffect(() => {
        if(selectedStates && gradeModal) {
            const gradeLevels = getGradeLevelsForState(selectedStates);
            const currentGrade = selectedGrade;
            
            if (currentGrade) {
                const normalizedGrade = normalizeGradeForDropdown(currentGrade, selectedStates);
                if (gradeLevels.includes(normalizedGrade)) {
                    setSelectedGrade(normalizedGrade);
                } else {
                    setSelectedGrade(gradeLevels[0] || '');
                }
            } else {
                setSelectedGrade(gradeLevels[0] || '');
            }
        }
    }, [selectedStates])

    useEffect(() => {
        if (selectedGrade && selectedStates) {
            checkActivityCount();
        }
    }, [selectedGrade, selectedStates, checkActivityCount]);

    const handleGradeUpdate = async (replace = false) => {
        if (!selectedGrade || !bookToEditGrade) return;
        
        const totalStandards = activityCount?.allStandardAbbr?.length || 0;
        if (totalStandards === 0) {
            const stateName = getStateNameFromCode(selectedStates) || selectedStates;
            showAlert(`For state ${stateName} there is no standard. If you want to run for this state, add the standard. Otherwise, change the state and run the standard.`, 'error');
            return;
        }
        
        setGradeLoader(true);
        try {
            let stateForAPI =
                selectedStates && selectedStates.toUpperCase().trim() === 'COMMON CORE'
                    ? 'COMMONCORE'
                    : getStateNameFromCode(selectedStates) || selectedStates;
            if (stateForAPI !== 'COMMONCORE') {
                stateForAPI = stateForAPI.toUpperCase().trim();
            }
            
            const gradeData = {
                grade_level: selectedGrade,
                state: stateForAPI,
                replace: replace
            };            
            const updateResult = await dispatch(handleUpdateBookGrade(bookToEditGrade.id, gradeData));
            
            if (updateResult && updateResult.error) {
                showAlert('Failed to update book grade level', 'error');
                setGradeLoader(false);
                return;
            }
            
            await dispatch(handleActivityGradeConfig({
                bookId: bookToEditGrade.id,
                grade_level: selectedGrade,
                state: stateForAPI,
                replace: replace
            }));
            await checkActivityCount();
            showAlert('Grade level updated successfully. Processing activities, it will take some time to complete.', 'success');
            setGradeModal(false);
            setBookToEditGrade(null);
            setSelectedGrade('');
            setSelectedStates('');
            setReplaceGradeModal(false);
            setPendingGradeUpdate(null);
        } catch (error) {
            showAlert('Failed to update grade level', 'error');
        } finally {
            setGradeLoader(false);
        }
    }

    return (
        <>
            <ModalSection
                open={alertForStatus}
                onClose={() => setAlertForStatus(false)}
            >
                <ModalContent>
                    Are you sure you want to {get(bookToActive, "active", true) ? "In-Active" : "Active"}  {get(bookToActive, "description", '')}
                    <ModalRow>
                        <Button
                            style={{ marginRight: '4px' }}
                            onClick={() => {
                                setAlertForStatus(false)
                                setBookToActive({})
                                setBookStatus('')
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            style={{ marginRight: '4px' }}
                            color="secondary"
                            variant="contained"
                            className={`${ActiveLoader !== -1 ? "disabled-button" : ""}`}
                            onClick={() => {
                                if (bookStatus === 'active') {
                                    handleActiveBook(bookToActive.id);
                                } else {
                                    handleDeActiveBook(bookToActive?.id);
                                }
                            }}
                        >
                            {ActiveLoader !== -1 ? <Loading size={20} white /> : 'Yes'}
                        </Button>
                    </ModalRow>
                </ModalContent>
            </ModalSection>
            <ModalSection
                open={replaceGradeModal}
                onClose={() => {
                    setReplaceGradeModal(false);
                    setPendingGradeUpdate(null);
                }}
            >
                <ModalContent>
                    <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 20 }}>
                        Replace Grade Level?
                    </div>
                    <div style={{ fontSize: 14, marginBottom: 20, lineHeight: '1.5' }}>
                        You have already run standards for grade level <strong>{pendingGradeUpdate?.existingGrade}</strong> for state <strong>{pendingGradeUpdate?.state}</strong>.
                        <br /><br />
                        If you proceed with grade level <strong>{pendingGradeUpdate?.newGrade}</strong>, the existing grade level <strong>{pendingGradeUpdate?.existingGrade}</strong> will be removed and replaced with the new one.
                    </div>
                    <ModalRow style={{ gap: 12 }}>
                        <Button
                            onClick={() => {
                                setReplaceGradeModal(false);
                                setPendingGradeUpdate(null);
                            }}
                        >
                            No
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            disabled={gradeLoader}
                            onClick={async () => {
                                await handleGradeUpdate(true);
                            }}
                        >
                            {gradeLoader ? <Loading size={20} white /> : 'Yes'}
                        </Button>
                    </ModalRow>
                </ModalContent>
            </ModalSection>
            <ModalSection
                open={gradeModal}
                onClose={() => {
                    setGradeModal(false);
                    setBookToEditGrade(null);
                    setSelectedGrade('');
                    setReplaceGradeModal(false);
                    setPendingGradeUpdate(null);
                }}
            >
                <ModalContent>
                    <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 20 }}>
                        Update Grade Level - {get(bookToEditGrade, "description", '')}
                    </div>
                    <FormControl variant="outlined" fullWidth style={{ marginBottom: 20 }}>
                        <InputLabel
                            id="grade_level_label"
                            style={{
                                backgroundColor: "#fff",
                                paddingLeft: 2,
                                paddingRight: 2,
                            }}
                        >
                             States
                        </InputLabel>
                        <Select
                            id="grade_level"
                            name="grade_level"
                            label="Grade Level"
                            value={selectedStates}
                            onChange={(e) => {
                                setSelectedStates(e.target.value);
                            }}
                        >
                            {STANDARD_GRADE_LEVEL.map((stateConfig) => {
                                const stateName = getStateNameFromCode(stateConfig.code) || stateConfig.state;
                                const displayValue = getStateNameDisplayForCode(stateName) || stateName;
                                return (
                                    <MenuItem key={stateConfig.code} value={stateName}>
                                        {displayValue}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                    <FormControl variant="outlined" fullWidth style={{ marginBottom: 20 }}>
                        <InputLabel
                            id="grade_level_label"
                            style={{
                                backgroundColor: "#fff",
                                paddingLeft: 2,
                                paddingRight: 2,
                            }}
                        >
                            Grade Level
                        </InputLabel>
                        <Select
                            id="grade_level"
                            name="grade_level"
                            label="Grade Level"
                            value={selectedGrade}
                            onChange={(e) => {
                                setSelectedGrade(e.target.value);
                            }}
                        >
                            {gradeDropdownLevels.map((grade) => (
                                <MenuItem key={grade} value={grade}>
                                    {grade}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 20, display: 'flex', alignItems: 'center', gap: '8px' }}>
                        Total Number of standards: {activityCountLoader ? <Loading size={16} /> : (activityCount?.allStandardAbbr?.length || 0)}
                    </div>
                    <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 20, display: 'flex', alignItems: 'center', gap: '8px' }}>
                        Numer of activities remaining: {activityCountLoader ? <Loading size={16} /> : (activityCount?.count !== null && activityCount?.count !== undefined ? activityCount.count : '-')}
                    </div>
                    <ModalRow style={{ gap: 12 }}>
                        <Button
                            onClick={() => {
                                setGradeModal(false);
                                setBookToEditGrade(null);
                                setSelectedGrade('');
                                setSelectedStates('');
                                setActivityCount(null);
                                setActivityCountLoader(false);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            disabled={!selectedGrade || gradeLoader || activityCountLoader || (activityCount?.count !== null && activityCount?.count !== undefined && activityCount.count === 0)}
                            onClick={async () => {
                                if (!selectedGrade || !bookToEditGrade) return;
                                
                                const totalStandards = activityCount?.allStandardAbbr?.length || 0;
                                if (totalStandards === 0) {
                                    const stateName = getStateNameFromCode(selectedStates) || selectedStates;
                                    showAlert(`For state ${stateName} there is no standard. If you want to run for this state, add the standard. Otherwise, change the state and run the standard.`, 'error');
                                    return;
                                }
                                
                                const bookGradeLevels = bookToEditGrade?.grade_levels || [];
                                const existingStateGrade = bookGradeLevels.find(gl => statesMatch(gl.state, selectedStates));
                                
                                if (existingStateGrade) {
                                    const existingGradeLevel = existingStateGrade.grade_level;
                                    const normalizedExisting = normalizeGradeForDropdown(existingGradeLevel, selectedStates);
                                    const normalizedSelected = normalizeGradeForDropdown(selectedGrade, selectedStates);                                    
                                    if (normalizedExisting !== normalizedSelected) {
                                        setReplaceGradeModal(true);
                                        return;
                                    }
                                }                                
                                await handleGradeUpdate(false);
                            }}
                        >
                            {gradeLoader ? <Loading size={20} white /> : 'Update'}
                        </Button>
                    </ModalRow>
                </ModalContent>
            </ModalSection>
            <ModalSection
                open={cloneModal}
                onClose={() => setCloneModal(false)}
            >
                <ModalContent>
                  <div style={{ fontSize:12 , lineHeight:"14px" }}>By cloning {get(bookToActive, "description", '')}, all activities, interactions, and configurations will be created with a new book ID. </div>
                    <Row gutter={[24, 24]} style={{ marginTop: 20, width:"100%"}}>
                        <Col span={24}>
                            <TextField
                                id="display_name"
                                name="display_name"
                                label="display name"
                                InputLabelProps={{ shrink: true, required: true }}
                                type="text"
                                variant="outlined"
                                onChange={(e) => {
                                    setBookTitle(e.target.value)
                                }}
                                value={bookTitle}
                            />
                        </Col>
                        <Col span={24}>
                        <CloneBookImage onChange={(val) => {
                            setBookImage(val?.url);
                        }} src={bookImage} />
                        </Col>
                    </Row>
                    <ModalRow style={{ gap:12}}>
                        <Button
                            color="secondary"
                            variant="contained"
                            style={{ marginRight: '4px' }}
                            onClick={() => {
                                setCloneModal(false)
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                             color="primary"
                             variant="contained"
                            disabled={!bookTitle || !bookImage || ActiveLoader != -1}
                            className={`${ActiveLoader != -1 ? "disabled-button" : ""}`}
                            onClick={handleClone}
                        >
                            {ActiveLoader != -1 ? <Loading size={20} white /> : 'Clone'}
                        </Button>
                    </ModalRow>
                </ModalContent>
            </ModalSection>
            <StableWrapper ref={stableWrapperRef} style={{ paddingTop: 24 }}>
                <FilterContainer className="FilterHeading">
                    <Card
                        type="inner"
                        title="Filters"
                    >
                        <Row>
                            <Col xs={24} lg={24} md={24} className="ColCardPadding">
                                <Card style={{ width: '100%' }}>
                                    <Input placeholder="Search by name" bordered={false} style={{ height: '32px' }} onChange={handleSearch} value={search} />
                                </Card>
                            </Col>
                        </Row>
                    </Card>
                </FilterContainer>
                {hasViewBooks && (
                <TableContainer>
                    <Tabs  
                        activeKey={activeTab} 
                        onChange={handleTabChange} 
                        defaultActiveKey="1" 
                        style={{ backgroundColor: '#fff', marginLeft: 10 }}
                    >
                        <TabPane tab={<div style={{ marginLeft: '10px' }}>Active Books</div>} key="1">
                            <Table stickyHeader aria-label="sticky table" style={{ width: "100%", textAlign: "center", backgroundColor: "#fff" }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ textAlign: "center" }}>id</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>Display Name</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>pages</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>Printable</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>Edit</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>Units</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {isEmpty(filteredBooks) &&
                                        <TableRow key={"0"} style={{ border: 0 }}>
                                          <TableCell
                                            colSpan={8}
                                            style={{ textAlign: "center" }}
                                          >
                                            No results
                                          </TableCell>
                                        </TableRow>
                                    }
                                    {(!isEmpty(filteredBooks)) &&
                                        paginatedActiveBooks.map((row) => (
                                            <TableRow key={row.id} style={{ '&:lastChild td, &:lastChild th': { border: 0 }, }} onClick={x => { }}>
                                                <TableCell style={{ textAlign: "center" }}>{row.id}</TableCell>
                                                <TableCell style={{ textAlign: "center" }}>{row.description}</TableCell>
                                                <TableCell style={{ textAlign: "center" }}>{get(row, "pages.length", 0)}</TableCell>
                                                <TableCell style={{ textAlign: "center" }}>{`${get(row, "printable", false) ? get(row, "printable", false) : ''}`}</TableCell>

                                                <TableCell style={{ textAlign: "center" }}>
                                                  <span
                                                    ref={openBookActionsMenuId === row.id ? bookActionsMenuTriggerRef : undefined}
                                                    style={{ display: 'inline-flex' }}
                                                  >
                                                  <Dropdown
                                                    open={openBookActionsMenuId === row.id}
                                                    onOpenChange={(nextOpen) => {
                                                        setOpenBookActionsMenuId(nextOpen ? row.id : null);
                                                    }}
                                                    overlay={
                                                      <Menu onClick={({ key }) => {
                                                        if (key === 'ebook') {
                                                          if (!canEdit) {
                                                            message.warning('You do not have permission to access this feature.');
                                                            setOpenBookActionsMenuId(null);
                                                            return;
                                                          }
                                                          setOpenBookActionsMenuId(null);
                                                          handleEditBook(row.id);
                                                        } else if (key === 'clone') {
                                                          if (!canAdd) {
                                                            message.warning('You do not have permission to access this feature.');
                                                            setOpenBookActionsMenuId(null);
                                                            return;
                                                          }
                                                          setOpenBookActionsMenuId(null);
                                                          setCloneModal(true);
                                                          setBookToActive(row);
                                                          setBookTitle(`${row.description?row.description+"(clone)":''}`);
                                                          setBookImage(row.img);
                                                        } else if (key === 'grade') {
                                                          if (!canEdit) {
                                                            message.warning('You do not have permission to access this feature.');
                                                            setOpenBookActionsMenuId(null);
                                                            return;
                                                          }
                                                          setOpenBookActionsMenuId(null);
                                                          setBookToEditGrade(row);
                                                          setGradeModal(true);
                                                        }
                                                      }}>
                                                        <Menu.Item key="ebook">Edit Book</Menu.Item>
                                                        <Menu.Item key="clone">Clone Book</Menu.Item>
                                                        <Menu.Item key="grade">Run Standard</Menu.Item>
                                                      </Menu>
                                                    }
                                                    trigger={['click']}
                                                  >
                                                    <ButtonDropdown  icon={<SettingsIcon />} />
                                                  </Dropdown>
                                                  </span>
                                                </TableCell>
                                                <TableCell style={{ textAlign: "center" }}>
                                                    {hasBookUnits(row.id) && (
                                                        <Button
                                                            variant="contained"
                                                            color='primary'
                                                            onClick={x => {
                                                              if (!canEdit) {
                                                                message.warning('You do not have permission to access this feature.');
                                                                return;
                                                              }
                                                              navigate(`/edit-book-units/?bookId=${row.id}`)
                                                            }} style={{ marginRight: '8px' }} >
                                                            Edit
                                                        </Button>
                                                    )}
                                                </TableCell>
                                                <TableCell style={{ textAlign: "center" }}>
                                                    <Button
                                                        variant="contained"
                                                        color='primary'
                                                        onClick={x => {
                                                          if (!canActivate) {
                                                            message.warning('You do not have permission to access this feature.');
                                                            return;
                                                          }
                                                          setAlertForStatus(true)
                                                          setBookToActive(row)
                                                          setBookStatus('active')
                                                        }} style={{ marginRight: '8px' }} >
                                                        {ActiveLoader === row.id ? <Loading size={'18px'} white /> : ('Active')}
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        {!isEmpty(filteredBooks) && (
                                            <TablePagination
                                                count={filteredBooks.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                backIconButtonProps={{
                                                    color: "secondary"
                                                }}
                                                nextIconButtonProps={{ color: "secondary" }}
                                            />
                                        )}
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </TabPane>
                        <TabPane tab="In-Active Books" key="2">
                            <Table stickyHeader aria-label="sticky table" style={{ width: "100%", textAlign: "center", backgroundColor: "#fff" }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ textAlign: "center" }}>id</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>Display Name</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>pages</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>Edit</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>Units</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {isEmpty(filteredBooksDeActive) &&
                                        <TableRow key={"0"} style={{ border: 0 }}>
                                          <TableCell
                                            colSpan={7}
                                            style={{ textAlign: "center" }}
                                          >
                                            No results
                                          </TableCell>
                                        </TableRow>
                                    }
                                    {(!isEmpty(filteredBooksDeActive)) &&
                                        paginatedInactiveBooks.map((row) => (
                                            <TableRow key={row.id} style={{ '&:lastChild td, &:lastChild th': { border: 0 }, }} onClick={x => { }}>
                                                <TableCell style={{ textAlign: "center" }}>{row.id}</TableCell>
                                                <TableCell style={{ textAlign: "center" }}>{row.description}</TableCell>
                                                <TableCell style={{ textAlign: "center" }}>{get(row, "pages.length", 0)}</TableCell>
                                                <TableCell style={{ textAlign: "center" }}>
                                                    <Button onClick={x => {
                                                      if (!canEdit) {
                                                        message.warning('You do not have permission to access this feature.');
                                                        return;
                                                      }
                                                      handleEditBook(row.id)
                                                    }} style={{ marginRight: '8px' }} >
                                                        <Edit></Edit>
                                                    </Button>
                                                </TableCell>
                                                <TableCell style={{ textAlign: "center" }}>
                                                    {hasBookUnits(row.id) && (
                                                        <Button
                                                            variant="contained"
                                                            color='primary'
                                                            onClick={x => {
                                                              if (!canEdit) {
                                                                message.warning('You do not have permission to access this feature.');
                                                                return;
                                                              }
                                                              navigate(`/edit-book-units/?bookId=${row.id}`)
                                                            }} style={{ marginRight: '8px' }} >
                                                            Edit
                                                        </Button>
                                                    )}
                                                </TableCell>
                                                <TableCell style={{ textAlign: "center" }}>
                                                    <Button
                                                        variant="contained"
                                                        color='crimson'
                                                        onClick={x => {
                                                          if (!canActivate) {
                                                            message.warning('You do not have permission to access this feature.');
                                                            return;
                                                          }
                                                          setAlertForStatus(true)
                                                          setBookToActive(row);
                                                          setBookStatus('Inactive')
                                                        }} style={{ marginRight: '8px', backgroundColor: 'crimson', color: 'white', textTransform: 'inherit' }} >
                                                        {ActiveLoader === row.id ? <Loading size={'18px'} white /> : 'InActive'}
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        {!isEmpty(filteredBooksDeActive) && (
                                            <TablePagination
                                                count={filteredBooksDeActive.length}
                                                rowsPerPage={rowsPerPageInActive}
                                                page={inActivepage}
                                                onPageChange={handleChangePageInActive}
                                                onRowsPerPageChange={handleChangeRowsPerPageinActive}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                backIconButtonProps={{
                                                    color: "secondary"
                                                }}
                                                nextIconButtonProps={{ color: "secondary" }}
                                            />
                                        )}
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </TabPane>
                    </Tabs>
                </TableContainer>
                )}
            </StableWrapper>
        </>
    );
};


export default BooksTable;
